import type { SVGProps } from 'react';

const GiftCardIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M3 9.5H21M12 9.5V21M5 6.5H19C20.1046 6.5 21 7.39543 21 8.5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V8.5C3 7.39543 3.89543 6.5 5 6.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6.5H9.75C8.50736 6.5 7.5 5.7165 7.5 4.75C7.5 3.7835 8.2835 3 9.25 3C10.7688 3 12 4.567 12 6.5ZM12 6.5H14.25C15.4926 6.5 16.5 5.7165 16.5 4.75C16.5 3.7835 15.7165 3 14.75 3C13.2312 3 12 4.567 12 6.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GiftCardIcon;
